import { render, staticRenderFns } from "./buka.vue?vue&type=template&id=4ea01c9c&scoped=true"
import script from "./buka.vue?vue&type=script&lang=js"
export * from "./buka.vue?vue&type=script&lang=js"
import style0 from "./buka.vue?vue&type=style&index=0&id=4ea01c9c&prod&lang=scss"
import style1 from "./buka.vue?vue&type=style&index=1&id=4ea01c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea01c9c",
  null
  
)

export default component.exports